import React from "react";
import {getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import {updatePackages} from "../../../../actions/WarehousePackageActions";
import {CANCEL_LOADED} from "../../../../queries/warehouseJobs";
import {compose} from "redux";
import {useDispatch} from "react-redux";
import {graphql} from "react-apollo";
import ArrowBack from "../../../../components/shared/icons/ArrowBack";


// In the loaded state, the user can cancel and send the package back to packed
// otherwise after several minutes the package will become fulfilled.  
const LoadedActions = (props) => {
  const { jobId } = props;

  if (jobId) {
    return <ActionsForSingleJob {...props} />;
  } else {
    return <ActionsForSinglePackage {...props} />;
  }
}

function ActionsForSingleJob(props) {
  const { warehouseId, jobId, packages } = props;

  const dispatch = useDispatch();

  const handleRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, packages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.PICKUP_READY )));
    // Send mutation to server
    return props.cancelLoaded(warehouseId, jobId, packages.map((p) => p.get("packageId")));
  }

  return (
    <ArrowBack
      onClick={props.active ? handleRevert : undefined}
      color="var(--grey-900)"
    />
  );
}

function ActionsForSinglePackage(props) {
  const { warehouseId, pack } = props;

  const dispatch = useDispatch();

  const handleRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, getPackageUID(pack), (p) => p.set("state", PACKAGE_STATES.PICKUP_READY )));
    // Send mutation to server
    return props.cancelLoaded(warehouseId, pack.get("jobId"), [pack.get("packageId")]);
  }

  return (
    <ArrowBack
      onClick={props.active ? handleRevert : undefined}
      color="var(--grey-900)"
    />
  );
}

const withQuery = compose(
  graphql(CANCEL_LOADED, {
    props: ({ mutate }) => ({
      cancelLoaded: (warehouseId, jobId, packageIds) => mutate({
        variables: { data: { warehouseId, jobId, packageIds } }
      })
    })
  }),
);

export default withQuery(LoadedActions);